import { fetchSettings } from "@api/procurements/settings";
import { useEffect, useState } from "react";

export const useSettings = (categoryName: string) => {
  const [settings, setSettings] = useState([]);

  useEffect(() => {
    if (categoryName) {
      fetchSettings(categoryName)
        .then((data) => {
          setSettings(data.data?.data);
        })
        .catch((err) => console.log(err));
    }
  }, [categoryName]);

  return {
    settings,
  };
};
